import React, { } from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField';
import { CampaignGroupFormValues } from 'src/models/CampaignGroup.model';
import useChannel from 'src/hooks/useChannel';
import ATMSelectValue from 'src/components/UI/atoms/formFields/ATMSelectValue/ATMSelectValue';

type Props = {
    formikProps: FormikProps<CampaignGroupFormValues>;
    onClose: () => void;
};


const CampaignGroupForm = ({ formikProps, onClose }: Props) => {

    const { Channel, isDataLoading } = useChannel();
    const channelOptions = Channel?.map((module) => {
        return {
            label: module?.channelName,
            value: module?._id,
        };
    });
    const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
    return (
        <div className='p-4 flex flex-col gap-6'>
            <div className='flex justify-between items-center'>
                <div className='text-xl font-medium'>  Form Heading </div>
                <button type='button' className='hover:bg-hover' onClick={onClose}>
                    Cancel
                </button>
            </div>
            <div className='flex flex-col gap-4'>
                <div>
                    <ATMTextField
                        name='campaignGroupName'
                        value={values.campaignGroupName}
                        onChange={(e) => {
                            setFieldValue('campaignGroupName', e.target.value);
                        }}
                        label='Campaign Group Name'
                        placeholder='campaign group name'
                        onBlur={handleBlur}
                    />
                </div>
                {/*Select Channel */}
                {/* <div className=''>
                    <ATMSelect
                        name='channelLabel'
                        value={values.channelLabel}
                        onChange={(newValue) => setFieldValue('channelLabel', newValue)}
                        onBlur={handleBlur}
                        label=' Channel'
                        placeholder='Select Channel'
                        options={channelOptions}
                        isLoading={isDataLoading}
                    />
                </div> */}

                <ATMSelectValue
                    name="channelLabel"
                    value={values?.channelLabel}
                    onChange={(value) => setFieldValue("channelLabel", value)}
                    options={channelOptions}
                    label="Select Channel"
                    isLoading={isDataLoading}
                />
            </div>
            <div>
                <ATMLoadingButton isLoading={isSubmitting} type='submit'>
                    Save
                </ATMLoadingButton>
            </div>
        </div>
    );
};

export default CampaignGroupForm;